import { createStyles, Paper, Theme, withStyles, WithStyles } from "@material-ui/core";
import React from "react";
import { Id } from "shared/src/models/framework/db";
import { PollCard } from "shared/src/network/requests/poll/poll-req-models";
import Question from "./Question";

const styles = (theme: Theme) =>
    createStyles({
        containerDiv: {
            position: "fixed",
            top: 0,
            left: 0,
            overflow: "hidden",
            width: 0,
            height: 0,
        },
        container: {
            width: "425px",
            backgroundColor: theme.palette.grey[100],
            padding: `${theme.spacing(1.5)}`,
            borderTopLeftRadius: 0,
            overflow: "hidden",
        },
    });

type Props = WithStyles<typeof styles> & {
    poll: Id<PollCard>;
};

const Component: React.ForwardRefRenderFunction<HTMLDivElement, Props> = (props, ref) => {
    const { classes, poll } = props;
    return (
        <div className={classes.containerDiv}>
            <Paper ref={ref} className={classes.container}>
                <Question key={poll.id} variant="share" poll={poll} />
            </Paper>
        </div>
    );
};

const ShareTemplate = withStyles(styles)(React.forwardRef(Component));

export default ShareTemplate;
